import { render } from "./OrganizationNotFoundErrorModal.vue?vue&type=template&id=2e863154"
const script = {}

import "./OrganizationNotFoundErrorModal.vue?vue&type=style&index=0&id=2e863154&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__